import React, { Suspense } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import './scss/style.scss';
import useFetchStartData from './hooks/useFetchStartData';
import { useSelector } from 'react-redux';
import Loader from './components/ui/Loader/Loader';
import { UnsavedChangesProvider } from './contexts/UnsavedChangesContext';
import CookieBanner from './components/CookieBanner/CookieBanner';
import PublicOnlyRoute from './components/PublicOnlyRoute';

const loading = (
	<div className="pt-3 text-center">
		<div className="sk-spinner sk-spinner-pulse"></div>
	</div>
);

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./pages/login/Login'));
const Register = React.lazy(() => import('./pages/register/RegisterStepOne'));
const RegisterStepTwo = React.lazy(() => import('./pages/register/RegisterStepTwo'));
const ForgotPassword = React.lazy(() => import('./pages/recovery-password/ForgotPassword'));
const RecoveryPassword = React.lazy(() => import('./pages/recovery-password/RecoveryPassword'));

const Page404 = React.lazy(() => import('./pages/page404/Page404'));
const Page500 = React.lazy(() => import('./pages/page500/Page500'));



function AppRoutes() {
	useFetchStartData();
	const isLoading = useSelector((state) => state.auth.isLoading);

	return (
		<Suspense fallback={loading}>
			<Routes>
				{isLoading ? (
					<Route path="*" element={
						<div className='p-relative d-flex justify-content-center align-items-center' style={{height: '100vh'}}>
							<Loader load={true}/>
						</div>
					} />
				) : (
					<>
						<Route exact path="/login" name="Login Page" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
						<Route exact path="/register" name="Register Page" element={<PublicOnlyRoute><Register /></PublicOnlyRoute>} />
						<Route exact path="/register-step-two" name="Register-2" element={<PublicOnlyRoute><RegisterStepTwo /></PublicOnlyRoute>} />
						<Route exact path="/forgot-password" element={<PublicOnlyRoute><ForgotPassword /></PublicOnlyRoute>} />
						<Route exact path="/recovery-password" element={<PublicOnlyRoute><RecoveryPassword /></PublicOnlyRoute>} />
						<Route exact path="/404" name="Page 404" element={<Page404 />} />
						<Route exact path="/500" name="Page 500" element={<Page500 />} />
						<Route path="*" name="Home" element={<DefaultLayout />} />
					</>
				)}
			</Routes>
		</Suspense>
	);
}

function App() {
	return (
		<HashRouter>
			<UnsavedChangesProvider>
				<AppRoutes />
				<CookieBanner />
			</UnsavedChangesProvider>
		</HashRouter>
	);
}

export default App;
